<template>
  <span ref='me_tooltip' class="me-tooltip">
    <slot></slot>
  </span>
</template>
<script>

import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

export default {
  props: {
    message: {
      type: String,
      required: true
    },

    type: {
      type: String,
      required: false,
      default: 'default'
    },

    maxWidth: {
      required: false,
      default: 'none'
    },

    tippyProps: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      instance: null,
      theme: {
        default: 'melhor-tooltip',
        danger: 'melhor-tooltip--danger',
        success: 'melhor-tooltip--success',
      }
    }
  },

  watch: {
    message(value) {
      this.instance.setContent(value);
    }
  },

  mounted() {
    this.instance = tippy(this.$refs.me_tooltip, {
      theme: this.theme[this.type],
      content: this.message,
      animation: 'shift-away',
      allowHTML: true,
      interactive: true,
      maxWidth: this.maxWidth,
      ...this.tippyProps,
    })
  }
};
</script>
